// extracted by mini-css-extract-plugin
module.exports = {"languageChanger":"styles_languageChanger__jUyU3"};